<template>
  <v-card
    class="observatory-control pa-1"
    width="140"
    color="rgba(255, 255, 255, 0.9)"
  >
    <v-row no-gutters align="center">
      <v-col>
        <v-checkbox
          class="checkbox"
          hide-details
          dense
          v-model="enabledObservatories"
          :label="OBSERVATORY.STAGE.name"
          :value="OBSERVATORY.STAGE.code"
          @change="onChangeFilters"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-icon size="16">mdi-triangle</v-icon>
      </v-col>
    </v-row>
    <v-row no-gutters align="center">
      <v-col>
        <v-checkbox
          class="checkbox"
          hide-details
          dense
          v-model="enabledObservatories"
          :label="OBSERVATORY.RAIN.name"
          :value="OBSERVATORY.RAIN.code"
          @change="onChangeFilters"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-icon size="16">mdi-checkbox-blank-circle</v-icon>
      </v-col>
    </v-row>
    <v-row no-gutters align="center">
      <v-col>
        <v-checkbox
          class="checkbox"
          hide-details
          dense
          v-model="enabledObservatories"
          :label="OBSERVATORY.CAMERA.name"
          :value="OBSERVATORY.CAMERA.code"
          @change="onChangeFilters"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-icon size="18">mdi-camera</v-icon>
      </v-col>
    </v-row>
    <v-row no-gutters align="center">
      <v-col>
        <v-checkbox
          class="checkbox"
          hide-details
          dense
          v-model="enabledObservatories"
          :label="OBSERVATORY.OVERFLOW_WATERWAY.name"
          :value="OBSERVATORY.OVERFLOW_WATERWAY.code"
          @change="onChangeFilters"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-icon size="18">mdi-alpha-l-box</v-icon>
      </v-col>
    </v-row>
    <v-row no-gutters align="center">
      <v-col>
        <v-checkbox
          class="checkbox"
          hide-details
          dense
          v-model="enabledObservatories"
          :label="OBSERVATORY.SUIJIN.name"
          :value="OBSERVATORY.SUIJIN.code"
          @change="onChangeFilters"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-icon size="18">mdi-alpha-s-circle</v-icon>
      </v-col>
    </v-row>
    <v-row no-gutters align="center">
      <v-col>
        <v-checkbox
          class="checkbox"
          hide-details
          dense
          v-model="enabledObservatories"
          label="ﾏﾝﾎｰﾙ水位"
          :value="OBSERVATORY.MANHOLE.code"
          @change="onChangeFilters"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-icon size="18">mdi-alpha-m-circle</v-icon>
      </v-col>
    </v-row>
    <v-row no-gutters align="center">
      <v-col>
        <v-checkbox
          class="checkbox"
          hide-details
          dense
          v-model="enabledObservatories"
          :label="OBSERVATORY.MANHOLE_WATERWAY.name"
          :value="OBSERVATORY.MANHOLE_WATERWAY.code"
          @change="onChangeFilters"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-icon size="18">mdi-bitbucket</v-icon>
      </v-col>
    </v-row>
    <v-row no-gutters align="center" v-if="isPrivateMode">
      <v-col>
        <v-checkbox
          class="checkbox"
          hide-details
          dense
          v-model="enabledObservatories"
          :label="OBSERVATORY.PUMP.name"
          :value="OBSERVATORY.PUMP.code"
          @change="onChangeFilters"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-icon size="18">mdi-water-pump</v-icon>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { OBSERVATORY } from "../../../enums/Type";
import { isPrivateMode } from "../../../utils/common";

export default {
  name: "ObservatoryControlLayer",
  data: () => ({
    OBSERVATORY,
    enabledObservatories: [],
    histories: [],
    selectWaterItem: 0,
    isPrivateMode
  }),
  created() {
    //
  },
  mounted() {
    this.enabledObservatories = this.$store.getters.riskSubControl.observatory;
  },
  methods: {
    onChangeFilters() {
      localStorage.setItem(
        "enabledObservatories",
        JSON.stringify(this.enabledObservatories)
      );
      this.$store.commit("SET_RISK_SUB_CONTROL", {
        observatory: this.enabledObservatories
      });
    }
  }
};
</script>
<style lang="scss">
.checkbox {
  .v-label {
    font-size: 14px;
  }
}
</style>
<style lang="scss" scoped>
.observatory-control {
  pointer-events: painted;
  .v-input--selection-controls {
    margin-top: 0;
  }
}
</style>
